import * as React from 'react';
import type { SVGProps } from 'react';
const SvgLock = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 21"
    {...props}
  >
    <path d="M16.5 14.523a3.25 3.25 0 0 1-3.25 3.25h-6.5a3.25 3.25 0 0 1-3.25-3.25v-3.25a3.25 3.25 0 0 1 3.25-3.25h6.5a3.25 3.25 0 0 1 3.25 3.25z" />
    <path
      fillRule="evenodd"
      d="M10 3.257a2.6 2.6 0 0 0-2.6 2.6V6.94a.65.65 0 0 1-1.3 0V5.857a3.9 3.9 0 0 1 7.8 0V6.94a.65.65 0 1 1-1.3 0V5.857a2.6 2.6 0 0 0-2.6-2.6"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgLock;
